module.exports = __webpack_public_path__ + "static/media/p1jbot.768b3d08.png";